export default {
  classNames: {
    currencyInput: 'currency-input',
    dateInput: 'date-input',
    searchbar: 'searchbar',
    selectInput: 'select-input',
    textAreaInput: 'textarea-input',
    textInput: 'text-input',
  },
  eventNames: {
    careerSearch: 'Execute Career Search',
    customPersonalityAssessmentReport: 'Custom Personality Assessment Report',
    exploreCareers: 'Explore Careers',
    feedContentClick: 'Feed Content Click',
    filterByEmployer: 'Filter by Employer',
    filterByJobCategory: 'Filter by Job Category',
    filterByMajor: 'Filter by Major',
    filterBySkill: 'Filter by Skill',
    filterResultsByCareerPath: 'Filter Results by Career Path',
    filterResultsByEducation: 'Filter Results by Education',
    filterResultsByEmployment: 'Filter Results by Employment',
    filterResultsBySkills: 'Filter Results by Skills',
    majorSearch: 'Execute Major Search',
    personalityAssessmentClick: 'Personality Assessment Click',
    restartPersonalityAssessment: 'Restart Personality Assessment',
    searchByCareer: 'Search by Career Click',
    searchByMajor: 'Search by Major Click',
    selectInterests: 'Select Interests',
    signup: 'Signup',
    viewPersonalityAssessmentResults: 'View Personality Assessment Results',
  },
}



// WEBPACK FOOTER //
// ./src/utils/constants/fullstory.js